import { apiRequest } from './index';

export const tasksAPI = {
  getAll: () => apiRequest("/tasks"),

  getMyTasks: () => apiRequest("/tasks"),
    // Теперь возвращаем все задачи, так как они по отделам

create: (taskData) => {
  const formattedTaskData = {
    title: taskData.title,
    description: taskData.description,
    priority: taskData.priority,
    status: taskData.status || 'pending',
    due_date: taskData.dueDate || taskData.due_date,
    department: taskData.department,
    shift_type: taskData.shift_type || taskData.shiftType,
    creator_id: taskData.creator_id || taskData.userId // ← используем userId как fallback
  };
  
  if (!formattedTaskData.title) throw new Error('Title is required');
  if (!formattedTaskData.department) throw new Error('Department is required');
  
  // Временно делаем creator_id необязательным
  // if (!formattedTaskData.creator_id) throw new Error('Creator ID is required');
  
  return apiRequest("/tasks", {
    method: "POST",
    body: formattedTaskData,
  });
},

  update: (taskId, updates) => {
    const formattedUpdates = {
      ...updates,
      due_date: updates.dueDate || updates.due_date,
      department: updates.department,
      shift_type: updates.shift_type || updates.shiftType
    };
    
    delete formattedUpdates.dueDate;
    delete formattedUpdates.shiftType;
    
    return apiRequest(`/tasks/${taskId}`, {
      method: "PUT",
      body: formattedUpdates,
    });
  },

  delete: (taskId) => 
    apiRequest(`/tasks/${taskId}`, { method: "DELETE" }),

  updateStatus: (taskId, status) => 
    apiRequest(`/tasks/${taskId}/status`, {
      method: "PATCH",
      body: { status },
    }),

  getByDepartment: (department) => 
    apiRequest(`/tasks/department/${encodeURIComponent(department)}`)
};
